// Mock data for Casa Bahiamar rental property

export const propertyData = {
  name: "Casa Bahiamar",
  tagline: "Waterfront Key Largo Luxury Estate",
  location: "Key Largo, Florida Keys",
  
  stats: {
    bedrooms: 5,
    bathrooms: 6,
    sleeps: 12,
    sqft: 6500,
    rate: "$20,000/month"
  },

  heroImage: "/images/property/canal.jpg",

  gallery: [
    { url: "/images/property/canal.jpg", caption: "Casa Bahiamar from Canal" },
    { url: "/images/property/front.jpg", caption: "Front View" },
    { url: "/images/property/pool.jpg", caption: "Heated Pool" },
    { url: "/images/property/level1.jpg", caption: "1st Level" },
    { url: "/images/property/greatroom.jpg", caption: "Great Room 800 SF" },
    { url: "/images/property/kitchen.jpg", caption: "Kitchen" },
    { url: "/images/property/canalview.jpg", caption: "Canal View" },
    { url: "/images/property/aerial.jpg", caption: "Aerial View" },
    { url: "/images/property/firepit.jpg", caption: "Fire Pit" },
    { url: "/images/property/dining.jpg", caption: "Dining Area" },
    { url: "/images/property/living.jpg", caption: "Living Room" },
    { url: "/images/property/truman.jpg", caption: "Truman Bedroom" },
    { url: "/images/property/adams.jpg", caption: "Adams Bedroom" },
    { url: "/images/property/screen.jpg", caption: "Screen Room" },
    { url: "/images/property/hammock.jpg", caption: "Hammock" },
    { url: "/images/property/boathouse.jpg", caption: "Boat House" }
  ],

  description: `Casa Bahiamar includes 5 flat screen TV's, wireless internet, 3 private balconies, a screened-in patio, and ample outdoor entertainment areas.

There is a gas BBQ, a firepit, and many lounging and eating areas. The house is fully stocked with all kitchen implements.

The huge 800 sq ft great room is great for entertaining.

The kitchen on the upper level has all the appliances and items you would expect from a luxury home and includes an island and eat-in bar.

The huge 12-seat dining table has a lovely view of Largo Sound. This waterfront house has deep water access to the bay and ocean, located on Adam's Cut.

It is literally a few hundred yards from John Pennekamp State Park and 30 minutes to Miami and all it has to offer.

There are many great nearby restaurants that serve local seafood or prepare yours, and most are accessible by land or water.

There is dock space for your boat or rental and plenty of trailer parking.`,

  features: [
    "3 King Beds + 1 Queen Bed + 2 Twin Beds + Sleeper Sofa",
    "Sleeps 12",
    "Heated Private Pool",
    "Deep Water Access to Bay & Ocean",
    "Located on Adam's Cut",
    "Boat Dock & Trailer Parking",
    "Elevator Access",
    "800 sq ft Great Room",
    "Covered Parking",
    "Hurricane Windows",
    "Fish Cleaning Table"
  ],

  amenities: {
    outdoors: [
      "Balcony",
      "Beach Chairs",
      "Bicycles",
      "Deck / Patio",
      "Fire Pit",
      "Kayak / Canoe",
      "Lawn / Garden",
      "Outdoor Furniture"
    ],
    entertainment: [
      "5 Flat Screen TVs",
      "Books",
      "Games",
      "Satellite / Cable",
      "Stereo",
      "Video Games"
    ],
    essential: [
      "Air Conditioning",
      "Bed Linens Provided",
      "Dryer",
      "Hair Dryer",
      "Heating",
      "Iron & Board",
      "Towels Provided",
      "Washing Machine",
      "Wireless Internet"
    ],
    kitchen: [
      "Blender",
      "Coffee Maker",
      "Dishes & Utensils",
      "Dishwasher",
      "Gas Grill",
      "Ice Maker",
      "Microwave",
      "Oven",
      "Refrigerator",
      "Stove",
      "Toaster"
    ],
    special: [
      "Boat Friendly",
      "Children Welcome",
      "Luxury Property",
      "Monthly Stay Rental",
      "Private Pool",
      "RV & Boat Parking"
    ]
  },

  locationInfo: `This property has many unique qualities that make it extremely desirable. Located on Adam's Cut with deep water access to the bay and ocean, it's only 26 miles from Miami-Dade County with all it has to offer and only 1 hour away from Miami International Airport. 

Adams Cut is the only connection between Florida Bay and the Atlantic and depending on your fishing or boating preference is ideal. 

There are many great nearby restaurants accessible by water as well as some of the best fishing, diving and snorkeling in the world. If you don't have a boat then take one of the many tours available.

Casa Bahiamar is extremely roomy and has a large lot, both features are rare in the Keys. The construction is concrete and has hurricane windows which also make it quiet.

Casa Bahiamar underwent a 1.5 million dollar renovation in 2012 and a pool was added in 2016. The owner is an artist and many of his paintings are in the house. The house is tastefully decorated and furnished.`,

  rates: {
    monthly: "$20,000",
    minimumStay: "28 nights"
  },

  contact: {
    name: "Gene Kohly",
    phone: "786-223-2936",
    email: "info@casabahiamar.com"
  },

  policies: {
    general: "We ask you to treat our house with respect. If you break something please be nice enough to say so. Garbage comes on Mondays and Thursdays and cans should be out by the street the night before.",
    cancellation: "Cancellations must be made over 30 days in advance.",
    accessibility: "The house is handicap friendly but not totally handicap accessible because bathroom doors are not wide enough, but it has an elevator.",
    events: "Events allowed with prior approval",
    children: "Children welcome"
  },

  ownerInfo: `Gene Kohly is a semi-retired general contractor and realtor who is now an artist and built many high-end custom homes. He fully renovated Casa Bahiamar - it was completely gutted and received a new layout, new electric, plumbing and air conditioning, solar panels and pool. Beth Kohly lovingly decorated and furnished the house in the Florida Keys style and chose all colors and furnishings.`
};

// Mock inquiry submission
export const submitInquiry = (inquiryData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Inquiry submitted:", inquiryData);
      resolve({ success: true, message: "Inquiry submitted successfully!" });
    }, 1000);
  });
};
